import { createReducer } from '@reduxjs/toolkit';
import {
  setCompanyOnboardingProgressAction,
  setOnboardingCompanyRequestsLoading,
} from 'store/actions/company-onboarding-actions';
import IOnboardingCompanyState from 'types/company/onboarding/IOnboardingCompanyState';

const initialState: IOnboardingCompanyState = {
  loading: false,
  progress: null,
};

const onboardingCompanyReducer = createReducer(initialState, builder => {
  return builder
    .addCase(setOnboardingCompanyRequestsLoading, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setCompanyOnboardingProgressAction, (state, action) => ({ ...state, progress: action.payload }));
});

export default onboardingCompanyReducer;
